export default function Features() {
  const features = [
    {
      icon: 'ri-customer-service-2-line',
      title: 'CRM de Vendas e Closer',
      description: 'Criamos funis comerciais completos dentro do Bitrix24, estruturando desde a entrada do lead até o fechamento com Closer. Organizamos etapas, cadências e automações para garantir um processo de vendas limpo, previsível e escalável.'
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Comunicação e Atendimento ao Cliente',
      description: 'Centralizamos toda a comunicação da empresa em um único lugar, integrando canais como WhatsApp, Instagram e Facebook ao Bitrix24. Assim, cada conversa fica registrada no CRM, com histórico completo e atendimento organizado por cliente.'
    },
    {
      icon: 'ri-task-line',
      title: 'Gestão Operacional e Entrega',
      description: 'Depois da venda, estruturamos fluxos automáticos de operação para execução do serviço ou entrega do produto. Criamos etapas, tarefas e responsáveis por departamento, garantindo que toda a equipe saiba exatamente o que fazer em cada novo projeto.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Automação Comercial e Documentos',
      description: 'Automatizamos processos que normalmente geram retrabalho, como assinatura de contratos, validação de dados e organização de documentos. Com integrações como ClickSign e Receita Federal, o Bitrix passa a executar tarefas sozinho e com segurança.'
    },
    {
      icon: 'ri-links-line',
      title: 'Integrações e APIs Sob Medida',
      description: 'Desenvolvemos integrações personalizadas entre o Bitrix24 e sistemas externos, conectando plataformas financeiras, ferramentas de assinatura, automações internas e aplicações específicas. Tudo para que a operação funcione de forma conectada e automática.'
    },
    {
      icon: 'ri-phone-line',
      title: 'IA e Telefonia Inteligente (OrbiSoft)',
      description: 'Para empresas que precisam de atendimento e vendas em alto volume, contamos com a OrbiSoft, parceira da BitFlow em telefonia e IA. Integrada ao Bitrix24, ela registra interações, cria cards e conecta oportunidades ao comercial.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white relative overflow-hidden">
      {/* Glow verde sutil no centro direito */}
      <div className="absolute top-1/2 right-0 w-[500px] h-[500px] bg-[#72BF3B]/[0.04] rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
      
      {/* Linha separadora sutil no topo */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-px bg-gradient-to-r from-transparent via-[#72BF3B]/25 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Funcionalidades */}
        <div className="mb-16">
          <p className="text-gray-500 text-sm font-mono mb-4">/soluções BitFlow</p>
          <h3 className="text-4xl font-bold text-[#162840] mb-4">
            Soluções que <span className="text-[#72BF3B]">transformam</span> sua operação
          </h3>
          <p className="text-lg text-gray-600 max-w-2xl mb-12">
            Processos completos e automações que fazem o Bitrix24 virar o sistema central da sua empresa
          </p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="bg-[#FAFBFC] p-6 rounded-xl border border-gray-100/80 hover:shadow-md hover:border-[#72BF3B]/30 hover:bg-white transition-all duration-300 hover:-translate-y-1 group cursor-pointer"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-[#72BF3B]/10 rounded-lg mb-4">
                  <i className={`${feature.icon} text-3xl text-[#72BF3B] group-hover:scale-110 transition-transform`}></i>
                </div>
                <h4 className="text-lg font-bold text-[#162840] mb-3">{feature.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Por que escolher */}
        <div className="grid lg:grid-cols-2 gap-8">
          <div className="bg-[#FAFBFC] p-8 rounded-2xl border border-gray-100/80">
            <h3 className="text-2xl font-bold mb-6 text-[#162840]">Por que escolher a <span className="text-[#72BF3B]">BitFlow</span>?</h3>
            <p className="text-gray-700 leading-relaxed">
              Porque a BitFlow não entrega uma implantação genérica. Nós analisamos a realidade do seu negócio para construir processos sob medida dentro do Bitrix24, aproveitando nossa experiência para organizar fluxos, automatizar rotinas e eliminar retrabalho. Vamos além das configurações básicas, explorando o potencial completo da plataforma com integrações, automações avançadas e soluções que realmente fazem sentido para o seu time. O resultado é um sistema ajustado à sua empresa, eficiente no dia a dia e preparado para crescer junto com a operação.
            </p>
          </div>

          <div className="bg-[#FAFBFC] p-8 rounded-2xl border border-gray-100/80">
            <h3 className="text-2xl font-bold mb-6 text-[#162840]">BitFlow + Bitrix24, <span className="text-[#72BF3B]">&nbsp;potencial&nbsp;máximo!</span></h3>
            <p className="text-gray-700 leading-relaxed">
              O Bitrix24 é uma das ferramentas mais completas do mercado, mas seu verdadeiro poder aparece quando ele é moldado para a realidade da empresa. Na <strong>BitFlow</strong>, unimos estratégia, experiência e profundidade técnica para transformar o Bitrix em um sistema indispensável, com automações avançadas, integrações inteligentes e processos construídos sob medida. Não entregamos apenas configurações, construímos uma operação conectada, organizada e pronta para crescer junto com o seu negócio.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}